export const IN_QUEUE = 'in_queue'
export const CALLED = 'called'
export const FAILED = 'failed'
export const SCHEDULED = 'scheduled'
export const SKIPPED = 'skipped'
